import {
  DayPickerStrings,
  FormikGraphQLDatePicker,
  onFormatDate,
} from 'components'
import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Proving } from 'model'
import { DayOfWeek, IDropdownOption, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { ParticipantListItem } from 'views/ParticipantViews'
import * as Yup from 'yup'

export type ProvingDetailsRentalCarFormValues = Proving
export class ProvingDetailsRentalCarFormSchema {
  constructor(provingDateFrom: string, provingDateTo: string) {
    return Yup.object().shape({
      rentalCar: Yup.object().shape({
        carType: Yup.string().required('Mietwagengröße ist ein Pflichtfeld'),
        // dateFrom: Yup.date()
        //   .required()
        //   .min(
        //     new Date(
        //       new Date().setDate(new Date(provingDateFrom).getDate() - 1)
        //     )
        //   ),
        // dateTo: Yup.date()
        //   .required()
        //   .when(
        //     'dateFrom',
        //     (dateFrom: any, schema: any) => dateFrom && schema.min(dateFrom)
        //   )
        //   .max(new Date(provingDateTo)),
      }),
    })
  }
}

export interface ProvingDetailsRentalCarValues {
  rentalCar: string
  dateFrom: Date
  dateTo: Date
}

export interface ProvingDetailsCarTypeValues {
  carType: string
}
// interface OptionsSettings{
//   options:string[],
//   type:string,
//   __typename:string
// }
export const ProvingDetailsRentalCarForm: React.FunctionComponent<{
  proving: Partial<Proving>
  notification?: boolean
  participant?: Partial<ParticipantListItem>
  wizardParticipants?: any
}> = ({ proving, notification, participant, wizardParticipants }) => {
  const { t } = useTranslation()
  // const {data}=useGetKeywordListsQuery()
  // let items:string[]=[]
  // const dataItems: OptionsSettings[] = data && data.globalSettings ? (data.globalSettings as OptionsSettings[]) : []
  // if(dataItems.length!==0){
  //   dataItems.forEach((setting)=>{
  //     if(setting.type==="vehicleTypes"&&setting.options)
  //     items=setting.options
  //   })
  // }

  // const carTypeOptionsDynamic :IDropdownOption[] = [
  //   { key: 'none', text: 'Kein Mietwagen' },
  //     ...items.map(
  //       (item: string,i) =>
  //         ({
  //           key: item+String(i),
  //           text: item,
  //         } as IDropdownOption)
  //     ),
  //   ]
  // dbg(carTypeOptionsDynamic,"ITEMS")
  const [selectedType, setSelectedType] = React.useState()
  let wizardParticipant
  if (wizardParticipants) {
    wizardParticipant =
      proving &&
      proving.participants &&
      proving.participants.find((x) => x._id === wizardParticipants[0])
  }

  const dateFromToUse = wizardParticipant
    ? wizardParticipant.dateFrom
    : proving.dateFrom
  const dateToToUse = wizardParticipant
    ? wizardParticipant.dateTo
    : proving.dateTo

  const carTypeOptions: IDropdownOption[] = [
    { key: 'none', text: 'Kein Mietwagen' },
    { key: 'compact', text: t('dropdown.option.ctSmall') },
    { key: 'midSize', text: t('dropdown.option.ctMedium') },
    { key: 'fullSize', text: t('dropdown.option.ctLarge') },
    { key: 'estate', text: t('dropdown.option.ctCombi') },
    { key: 'minibus', text: t('dropdown.option.ctMinibus') },
  ]

  const resetForm = (fieldProps: FieldProps<any>) => {
    fieldProps.form.setFieldValue('rentalCar.dateFrom', null)
    fieldProps.form.setFieldValue('rentalCar.dateTo', null)
  }

  // const validateDateFrom = () => {
  //   if (participant) {
  //     return new Date(participant.provingDateFrom as any)
  //   } else {
  //     return new Date(proving.dateFrom)
  //   }
  // }

  // const validateDateTo = () => {
  //   if (participant) {
  //     return new Date(participant.provingDateTo as any)
  //   } else {
  //     return new Date(proving.dateTo)
  //   }
  // }

  return (
    <FormStack>
      {notification && (
        <FieldStack>
          <Label>
            {t(
              'Achtung! Es sind mehrere Einträge ausgewählt! Die Werte werden bei allen ausgewählten Einträgen mit den Werten aus der Formularmaske überschrieben!'
            )}
          </Label>
        </FieldStack>
      )}
      <FieldStack>
        <Label>{t('field.rentalCar.label')}</Label>
        <FieldStackItem
          name="rentalCar.carType"
          render={(fieldProps) => {
            setSelectedType(fieldProps.field.value)
            return (
              <FormikDropdown
                required={true}
                label={t('field.carType.label')}
                {...fieldProps}
                options={carTypeOptions}
                onChanged={(option) => {
                  if (option.key === 'none') {
                    setSelectedType(option.key)
                    resetForm(fieldProps)
                  } else {
                    setSelectedType(option.key)
                    fieldProps.form.setFieldValue(
                      'rentalCar.dateFrom',
                      dateFromToUse
                    )
                    fieldProps.form.setFieldValue(
                      'rentalCar.dateTo',
                      dateToToUse
                    )
                  }
                }}
              />
            )
          }}
        />
      </FieldStack>

      {selectedType !== 'none' && (
        <>
          <FieldStack horizontal={true}>
            <FieldStackItem
              required={true}
              name="rentalCar.dateFrom"
              label={t('field.dateFrom.label')}
              component={FormikGraphQLDatePicker}
              // minDate={validateDateFrom()}
              // maxDate={validateDateTo()}
              firstDayOfWeek={DayOfWeek.Monday}
              strings={DayPickerStrings}
              showWeekNumbers={true}
              formatDate={onFormatDate}
              initialPickerDate={new Date(dateFromToUse)}
            />
            <FieldStackItem
              required={true}
              name="rentalCar.dateTo"
              label={t('field.dateTo.label')}
              component={FormikGraphQLDatePicker}
              // minDate={validateDateFrom()}
              // maxDate={validateDateTo()}
              firstDayOfWeek={DayOfWeek.Monday}
              strings={DayPickerStrings}
              showWeekNumbers={true}
              formatDate={onFormatDate}
              initialPickerDate={new Date(dateToToUse)}
            />
          </FieldStack>
        </>
      )}
    </FormStack>
  )
}
